export default __webpack_public_path__ + "static/media/one-more-light.85150c50.jpg";